/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type {
  CreateSyncSessionRequest,
  CreateSyncSessionResponse,
  GetALMIssuesRequest,
  GetALMIssuesResponse,
  GetAlmItemTypeRequest,
  GetAlmItemTypeResponse,
  GetLinkTypeResponse,
  GetLinkTypesResponse,
  GetSessionInfoResponse,
  GetStatusResponse,
  NoData,
  UpdateLinkTypeRequest,
} from "./models";
import {
  createSyncSessionResponseSchema,
  getALMIssuesResponseSchema,
  getAlmItemTypeResponseSchema,
  getLinkTypeResponseSchema,
  getLinkTypesResponseSchema,
  getSessionInfoResponseSchema,
  getStatusResponseSchema,
  noDataSchema,
} from "./schemas";

export class AlmsyncCommonApiClient {
  constructor(private caller: ApiCaller) {}

  async deleteCompany(timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.companies.delete",
        variables: {},
      },
      "deleteCompany",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async createSession(
    payload: CreateSyncSessionRequest,
    timeout?: number,
  ): Promise<CreateSyncSessionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.create",
        variables: {},
      },
      "createSession",
      payload,
      { schema: createSyncSessionResponseSchema, timeout },
    );
  }

  async getSessionInfo(sessionId: string, timeout?: number): Promise<GetSessionInfoResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.get",
        variables: { sessionId: String(sessionId) },
      },
      "getSessionInfo",
      {},
      { schema: getSessionInfoResponseSchema, timeout },
    );
  }

  async removeSyncSession(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.delete",
        variables: { sessionId: String(sessionId) },
      },
      "removeSyncSession",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getStatus(sessionId: string, timeout?: number): Promise<GetStatusResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.sync.get",
        variables: { sessionId: String(sessionId) },
      },
      "getStatus",
      {},
      { schema: getStatusResponseSchema, timeout },
    );
  }

  async stop(sessionId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.sync.stop",
        variables: { sessionId: String(sessionId) },
      },
      "stop",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getLinkTypes(sessionId: string, timeout?: number): Promise<GetLinkTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.link_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getLinkTypes",
      {},
      { schema: getLinkTypesResponseSchema, timeout },
    );
  }

  async getLinkType(
    sessionId: string,
    linkTypeId: string,
    timeout?: number,
  ): Promise<GetLinkTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.link_types.${linkTypeId}.get",
        variables: { sessionId: String(sessionId), linkTypeId: String(linkTypeId) },
      },
      "getLinkType",
      {},
      { schema: getLinkTypeResponseSchema, timeout },
    );
  }

  async updateLinkType(
    payload: UpdateLinkTypeRequest,
    sessionId: string,
    linkTypeId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.link_types.${linkTypeId}.update",
        variables: { sessionId: String(sessionId), linkTypeId: String(linkTypeId) },
      },
      "updateLinkType",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteLinkType(sessionId: string, linkTypeId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.link_types.${linkTypeId}.delete",
        variables: { sessionId: String(sessionId), linkTypeId: String(linkTypeId) },
      },
      "deleteLinkType",
      {},
      { schema: noDataSchema, timeout },
    );
  }

  async getAlmIssues(
    payload: GetALMIssuesRequest,
    timeout?: number,
  ): Promise<GetALMIssuesResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.alm_issues.get",
        variables: {},
      },
      "getAlmIssues",
      payload,
      { schema: getALMIssuesResponseSchema, timeout },
    );
  }

  async getSyncSessionAlmItemType(
    payload: GetAlmItemTypeRequest,
    sessionId: string,
    timeout?: number,
  ): Promise<GetAlmItemTypeResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.sessions.${sessionId}.alm_item_types.get",
        variables: { sessionId: String(sessionId) },
      },
      "getSyncSessionAlmItemType",
      payload,
      { schema: getAlmItemTypeResponseSchema, timeout },
    );
  }
}
